<template>
  <table v-if="treeData.accountName" style="display: flex; justify-content: center">
    <tr style="display: flex; flex-direction: column; justify-content: center;">
      <td
        :colspan="Array.isArray(treeData.children) ? treeData.children.length * 2 : 1"
        :class="{
          parentLevel:Array.isArray(treeData.children) && treeData.children.length,
          extend: treeData.extend}"
      >
        <div :class="{ node: true }">
          <div :style="{backgroundColor: treeData.color}" class="person" @click="$emit('click-node', treeData)">
            <div class="name">{{ treeData.accountName }}</div>
            <div class="amonut">{{ treeData.num }}</div>
          </div>
        </div>
      </td>
    </tr>
    <tr  v-if="Array.isArray(treeData.children) && treeData.children.length" style="display: flex; flex-direction: column; justify-content: space-between;">
      <td v-for="(children, index) in treeData.children" :key="index" colspan="2" class="childLevel">
        <TreeChart :tree-data="children" @click-node="$emit('click-node', $event)" />
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'TreeChart',
  props: ['treeData'],
  mounted() {
  },
  methods: {

  }
}
</script>

<style scoped>
table {
  border-collapse: separate !important;
  border-spacing: 0 !important;
  font-size: 20px;
  margin: 0 auto;
}
td {
  position: relative;
  vertical-align: top;
  /* padding-right: 200px; */
  text-align: center;
}
.parentLevel {
  padding-right: 200px;
}
.parentLevel::before {
  content: "";
  position: absolute;
  bottom: calc(50% - 1px);
  right: 100px;
  width: 100px;
  border-bottom: 2px solid #ccc;
}
/* .extend::after {
  content: "";
  position: absolute;
  bottom: calc(50% - 1px);
  left: -100px;
  width: 100px;
  border-bottom: 2px solid #ccc;
} */
.childLevel::before {
  content: "";
  position: absolute;
  left: -18%;
  bottom: 50%;
  width: 100px;
  border-bottom: 2px solid #ccc;
  transform: translate3d(0, 1px, 0);
}
.childLevel::after {
  content: "";
  position: absolute;
  bottom: 0;
  top: 0;
  left: -100px;
  border-left: 2px solid #ccc;
}
.childLevel:first-child:before,
.childLevel:last-child:before {
  display: none;
}
.childLevel:first-child:after {
  top: 50%;
  width: 100px;
  border: 2px solid;
  border-color: #ccc transparent transparent #ccc;
  border-radius: 6px 0 0 0;
  transform: translate3d(0, 1px, 0);
}
.childLevel:last-child:after {
  bottom: 50%;
  width: 100px;
  border: 2px solid;
  border-color: transparent transparent #ccc #ccc ;
  border-radius: 0 6px 0 0;
  transform: translate3d(0, -1px, 0);
}
.childLevel:first-child.childLevel:last-child::after {
  left: auto;
  border-radius: 0;
  border-color: transparent #ccc transparent transparent;
  transform: translate3d(1px, 0, 0);
}


.node {
  position: relative;
  display: inline-block;
  /* margin: 50px 1em 0; */
  box-sizing: border-box;
  text-align: center;
  height: 86px;
}
.node .person {
  position: relative;
  display: inline-block;
  z-index: 2;
  /* width: 6em; */
  overflow: hidden;
  width: 170px;
  height: 86px;
}
.node .person .avat {
  display: block;
  width: 4em;
  height: 4em;
  margin: auto;
  overflow: hidden;
  background: #fff;
  border: 1px solid #ccc;
  box-sizing: border-box;
}
.node .person .avat img {
  width: 100%;
  height: 100%;
}
.node .person .name {
  height: 2em;
  line-height: 2em;
  overflow: hidden;
  width: 100%;
  color: #fff;
}
.node .person .amonut {
  font-weight: 600;
  color: #fff;
}
.node.hasMate::after {
  content: "";
  position: absolute;
  left: 2em;
  right: 2em;
  top: 2em;
  border-top: 2px solid #ccc;
  z-index: 1;
}

</style>
